module.exports = __webpack_public_path__ + "img/satoma-untitled.7cf2f5b.jpg";